import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { TokenStorageService } from '../services/token.storage.service';
import {NavigationService} from '../services/navigation-service';
import {UserRole} from '../model/role.enum';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private tokenStorageService: TokenStorageService,
    private navigationService: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const requiredRoles = route.data['roles'] as UserRole[];

    if (!requiredRoles || requiredRoles.length === 0) {
      return false;
    }

    if (!this.tokenStorageService.hasAnyRole(requiredRoles)) {
      this.navigationService.backOrHome();
      return false;
    }

    return true;
  }
}
